import { render, staticRenderFns } from "./RunnitsSubscriptionsPage.vue?vue&type=template&id=8120ab2e&scoped=true"
import script from "./RunnitsSubscriptionsPage.vue?vue&type=script&lang=ts"
export * from "./RunnitsSubscriptionsPage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsSubscriptionsPage.vue?vue&type=style&index=0&id=8120ab2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8120ab2e",
  null
  
)

export default component.exports